import { forwardRef as S, useState as L, useMemo as R, useCallback as g } from "react";
import { useDerivedState as y, useIsomorphicLayoutEffect as E } from "@material-bank/ds-utils";
import { Input as T } from "../Input.js";
import { jsx as F } from "theme-ui/jsx-runtime";
const i = (s) => s !== null ? String(s) : "", _ = S((s, b) => {
  const {
    value: m,
    defaultValue: d,
    min: n,
    max: u,
    onNumberChange: V,
    onBlur: p,
    ...v
  } = s, f = m !== void 0, [o, I] = y({
    value: m,
    initialValue: d ?? null,
    onChange: V
  }), [h, r] = L(i(o));
  E(() => {
    r(i(m ?? null));
  }, [m]);
  const x = R(() => {
    if (n === void 0 && u === void 0)
      return String(Number.MIN_SAFE_INTEGER).length;
    const e = n !== void 0 ? String(n).length : 0, t = u !== void 0 ? String(u).length : 0;
    return Math.max(e, t);
  }, [n, u]), l = g((e) => {
    e !== o && I(e);
  }, [o, I]), c = g((e) => Math.max(Math.min(e, u ?? 1 / 0), n ?? -1 / 0), [n, u]), C = g((e) => {
    const t = e.replace(/[^\d-]/g, "");
    if (!t) {
      l(null), r("");
      return;
    }
    const a = Number.parseFloat(t);
    if (Number.isNaN(a)) {
      t === "-" && (n === void 0 || n < 0) && r(t);
      return;
    }
    const N = c(a);
    N === a && l(N), r(i(a));
  }, [n, l, c]), M = g((e) => {
    p == null || p(e);
    const t = Number.parseFloat(h);
    if (Number.isNaN(t)) {
      l(null), r(i(f ? o : null));
      return;
    }
    const a = c(t);
    l(a), r(i(f ? o : a));
  }, [f, o, h, l, r, c, p]);
  return /* @__PURE__ */ F(T, {
    ref: b,
    value: h,
    inputMode: "numeric",
    min: n,
    max: u,
    maxLength: x,
    ...v,
    onTextChange: C,
    onBlur: M
  });
});
_.displayName = "NumberInput";
export {
  _ as NumberInput
};
